module.exports = __webpack_public_path__ + "static/media/used_certified_biobased_product.ca246478.png";